module.exports = __webpack_public_path__ + "static/media/skytree-2.5d86f1ef.jpg";